var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Check",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    fill: "#ced3ed",
    r: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26 44c-.53 0-1.04-.21-1.41-.59l-9-9c-.78-.78-.78-2.05 0-2.83s2.05-.78 2.83 0l7.55 7.55 19.59-20.52c.76-.8 2.03-.83 2.83-.07s.83 2.03.07 2.83l-21 22c-.37.39-.88.61-1.42.62h-.02z",
    fill: "#4257ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b279dcbe4c0609208aaed5811f30b249.svg";
export { ForwardRef as ReactComponent };